<template>
  <section>
    <b-row>
      <b-col
        lg="4"
        cols="12"
      >
        <b-card>
          <b-card-text>

            <div class="text-right">
              <b-badge :variant="statusVariant(attendanceDetails?.status)">
              <span v-if="attendanceDetails?.status === ''">
                Pending
              </span>
                <span v-else>
                {{ attendanceDetails?.status.toUpperCase() }}
              </span>
              </b-badge>
            </div>
            <p class="text-uppercase custom-text-disabled">
              Details
            </p>

            <b-list-group flush>

              <b-list-group-item><h6 class="text-base font-weight-semibold">
                ID: <b-badge variant="primary">
                  {{ user?.employee_number }}
                </b-badge>
              </h6></b-list-group-item>

              <b-list-group-item><h6 class="text-base font-weight-semibold">
                Department: <span class="text-body-2">{{ user?.department?.name }}</span>
              </h6></b-list-group-item>

              <b-list-group-item><h6 class="text-base font-weight-semibold">
                Name: <span class="text-body-2">{{ user?.name }}</span>
              </h6></b-list-group-item>
              <b-list-group-item><h6 class="text-base font-weight-semibold">
                Start Time: <span
                  v-if="attendanceDetails?.start_time"
                  class="text-body-2"
                > {{
                  [attendanceDetails?.start_time, "HH:mm:ss"]
                    | moment("LT")
                }} </span> <b-badge
                  v-else
                  variant="danger"
                >
                  N/A
                </b-badge>
              </h6></b-list-group-item>

              <b-list-group-item><h6 class="text-base font-weight-semibold">
                End Time: <span
                  v-if="attendanceDetails?.end_time"
                  class="text-body-2"
                >{{
                  [attendanceDetails?.end_time, "HH:mm:ss"]
                    | moment("LT")
                }}</span> <b-badge
                  v-else
                  variant="danger"
                >
                  N/A
                </b-badge>
              </h6></b-list-group-item>

              <b-list-group-item><h6 class="text-base font-weight-semibold">
                Date: <span class="text-body-2">{{ attendanceDetails?.requested_date | moment("ll") }}</span>
              </h6></b-list-group-item>

              <b-list-group-item><h6 class="text-base font-weight-semibold">
                Description: <span class="text-body-2">{{ attendanceDetails?.description }}</span>
              </h6></b-list-group-item>

              <b-list-group-item><h6 class="text-base font-weight-semibold">
                Address: <span class="text-body-2">{{ attendanceDetails?.address }}</span>
              </h6></b-list-group-item>

              <b-list-group-item><h6 class="text-base font-weight-semibold">
                Contact Person: <span class="text-body-2">{{ attendanceDetails?.contact_person }}</span>
              </h6></b-list-group-item>

            </b-list-group>
          </b-card-text>
        </b-card>

        <b-card v-if="attendanceDetails?.visiting_completed === 1 || (attendanceDetails?.user_id === authUser?.id && $permissionAbility(VISIT_ATTENDANCE_COMPLETED_VISITING,permissions))">
          <b-card-text>
            <p class="text-uppercase custom-text-disabled">
              Visited Info
            </p>
            <div class="text-right">
              <template v-if="attendanceDetails?.visiting_completed === 0 && attendanceDetails?.user_id === authUser?.id">
                <b-button @click="showModal" variant="warning">Done Visiting?</b-button>
              </template>

              <template v-if="attendanceDetails?.visiting_completed === 1">
                <b-badge variant="success">Already Visited</b-badge>
              </template>

            </div>

            <template v-if="attendanceDetails?.visiting_completed">
              <div class="text-right mt-1">
                <b-button
                    v-b-tooltip.hover
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="outline-primary"
                    class="btn-icon"
                    :title='attendanceDetails?.visiting_remarks'
                >
                  <feather-icon class="btn-icon" icon="InfoIcon" />
                </b-button>
              </div>
              <div v-if="attendanceDetails?.images?.length" class="d-flex flex-wrap mt-2">
                <div
                    v-for="(image, index) in attendanceDetails.images"
                    :key="index"
                    class="m-1"
                    style="width: 100px; height: 100px; overflow: hidden;"
                >
                  <a
                      :href="image.url"
                      target="_blank"
                      rel="noopener noreferrer"
                  >
                    <img
                        :src="image.url"
                        alt="Attachment"
                        class="img-thumbnail"
                        style="width: 100%; height: 100%; object-fit: cover;"
                    />
                  </a>
                </div>
              </div>
            </template>

          </b-card-text>
        </b-card>
      </b-col>

      <b-col
        lg="8"
        cols="12"
      >
        <b-card>

          <template v-if="attendanceDetails?.visiting_completed === 0 && attendanceDetails?.user_id === authUser?.id && isTodayRequestedDate">
            <div v-if="!isLoading" class="d-flex w-100 justify-content-end mb-1">
              <b-button
                v-if="attendanceDetails?.show_check_in"
                id="tooltip-check-out"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                v-b-tooltip.hover.bottom.v-success
                variant="success"
                title="Check In"
                size="sm"
                class="btn-icon rounded-circle mr-1"
                @click="getLocationAndCheckIn"
              >
                <feather-icon
                  size="21"
                  icon="ClockIcon"
                />
              </b-button>
              <b-button
                v-else
                id="tooltip-check-out"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                v-b-tooltip.hover.bottom.v-danger
                variant="danger"
                title="Check Out"
                size="sm"
                class="btn-icon rounded-circle mr-1"
                @click="getLocationAndCheckOut"
              >
                <feather-icon
                  size="21"
                  icon="CheckCircleIcon"
                />
              </b-button>
            </div>

            <template v-else>
              <div class="d-flex w-100 justify-content-end mb-1">
                <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    class="btn-icon rounded-circle mr-1"
                    size="sm"
                    disabled
                >
                  <b-spinner small />
                  <span class="sr-only">Loading...</span>
                </b-button>
              </div>
            </template>
          </template>

          <div>
            <div
                v-if="attendanceDetails?.visiting_completed === 1 && attendanceDetails?.status === 'pending' && (checkApprovePermission(attendanceDetails) || checkRejectPermission(attendanceDetails))"
                class="d-flex justify-content-end mb-2"
            >
              <span v-if="checkRejectPermission(attendanceDetails)" @click="rejectModalOpen(attendanceDetails)" class="mr-1">
                <button class="cursor-pointer btn btn-danger">Reject</button>
              </span>

                  <span v-if="checkApprovePermission(attendanceDetails)" @click="onApprove(attendanceDetails)">
                <button class="cursor-pointer btn btn-success">Approve</button>
              </span>
            </div>
            <!-- table -->
            <vue-good-table
              style-class="vgt-table table-custom-style striped"
              :line-numbers="false"
              :rows="rows"
              :columns="columns"
              :sort-options="{
                enabled: true,
                multipleColumns: true,
              }"
              :pagination-options="{
                enabled: true,
                perPage: pageLength,
              }"
            >

              <template
                slot="table-row"
                slot-scope="props"
              >
                <!-- format_worked_minutes -->
                <span v-if="props.column.field === 'format_worked_minutes'">
                  <template v-if="props?.row?.worked_minutes">
                     <span class="font-weight-bold"> {{ formattedTime(props?.row?.worked_minutes) }} </span>
                  </template>

                </span>


                <!-- Column: Common -->
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>

                <!-- Check in -->
                <template v-if="props.column.field === 'format_check_in'">
                  <span v-if="props?.row?.check_in">
                    <template v-if="props?.row?.remarks">
                      <span class="reconciled-time font-weight-bold">
                        {{ formatFnTableCheckIn(props?.row?.check_in) }}
                      </span>
                    </template>

                    <template v-else>
                      <span class="font-weight-bold"> {{ formatFnTableCheckIn(props?.row?.check_in) }} </span>
                    </template>

                    <br>
                    <b-badge variant="primary">latitude: {{ props?.row?.check_in_latitude }}</b-badge>
                    <br>
                    <b-badge variant="success">longitude: {{ props?.row?.check_in_longitude }}</b-badge>

                     <div class="map-container">
                        <iframe
                            width="100%"
                            height="150"
                            frameborder="0"
                            style="border:0"
                            allowfullscreen
                            loading="lazy"
                            :src="'https://www.google.com/maps?q=' + props?.row?.check_in_latitude + ',' + props?.row?.check_in_longitude + '&z=15&output=embed'"
                        ></iframe>
                      </div>

                  </span>

                  <b-badge
                    v-else
                    variant="danger"
                  >
                    N/A
                  </b-badge>
                </template>

                <!-- checkout  -->
                <template v-if="props.column.field === 'format_check_out'">
                  <span v-if="props?.row?.check_out">
                    <template v-if="props?.row?.remarks">
                      <span class="reconciled-time font-weight-bold">
                        {{ formatFnTableCheckIn(props?.row?.check_out) }}
                      </span>
                    </template>

                    <template v-else>
                      <span class="font-weight-bold"> {{ formatFnTableCheckIn(props?.row?.check_out) }} </span>
                    </template>

                    <br>
                    <b-badge variant="primary">latitude: {{ props?.row?.check_out_latitude }}</b-badge>
                    <br>
                    <b-badge variant="success">longitude: {{ props?.row?.check_out_longitude }}</b-badge>

                    <div class="map-container">
                      <iframe
                          width="100%"
                          height="150"
                          frameborder="0"
                          style="border:0"
                          allowfullscreen
                          loading="lazy"
                          :src="'https://www.google.com/maps?q=' + props?.row?.check_out_latitude + ',' + props?.row?.check_out_longitude + '&z=15&output=embed'"
                      ></iframe>
                    </div>


                  </span>
                  <b-badge
                    v-else
                    variant="danger"
                  >
                    N/A
                  </b-badge>
                </template>

                <!-- worked hour -->

              </template>

              <!-- format_check_in -->

              <!-- pagination -->
              <template
                slot="pagination-bottom"
                slot-scope="props"
              >
                <div class="d-flex justify-content-between flex-wrap">
                  <div class="d-flex align-items-center mb-0 mt-1">
                    <span class="text-nowrap"> Showing 1 to </span>
                    <b-form-select
                      v-model="pageLength"
                      :options="['10', '25', '50', '100', '500']"
                      class="mx-1"
                      @input="
                        (value) =>
                          props.perPageChanged({ currentPerPage: value })
                      "
                    />
                    <span class="text-nowrap">
                      of {{ props.total }} entries
                    </span>
                  </div>
                  <div>
                    <b-pagination
                      :value="1"
                      :total-rows="props.total"
                      :per-page="pageLength"
                      first-number
                      last-number
                      align="right"
                      prev-class="prev-item"
                      next-class="next-item"
                      class="mt-1 mb-0"
                      @input="
                        (value) => props.pageChanged({ currentPage: value })
                      "
                    >
                      <template #prev-text>
                        <feather-icon
                          icon="ChevronLeftIcon"
                          size="18"
                        />
                      </template>
                      <template #next-text>
                        <feather-icon
                          icon="ChevronRightIcon"
                          size="18"
                        />
                      </template>
                    </b-pagination>
                  </div>
                </div>
              </template>
            </vue-good-table>


          </div>

        </b-card>


      </b-col>
    </b-row>

    <!-- apply modal -->
    <b-modal
        id="modal-apply-form"
        centered
        :title="
        modelType == 'editModel'
          ? 'Visit Attendance Details'
          : 'Visit Attendance Request'
      "
        hide-footer
        @hidden="hiddenApplyModal"
        no-close-on-backdrop
        size="lg"
    >
      <validation-observer ref="applyValidation">
        <b-form v-on:submit.prevent="applyFromSubmit">

          <b-row class="justify-content-center">
            <b-col cols="12" md="8" lg="6">
              <div class="text-center">

                <template v-if="userData?.user_id">
                  <b-avatar default="''" :src="userData?.user?.data?.avatar === '' ? '/avatar.svg' : userData?.user?.data?.avatar" >
                  </b-avatar>
                  <h4>{{ userData?.user?.data?.name }} <b-badge variant="light-secondary">{{
                      userData?.user?.data?.employee_number
                    }}</b-badge></h4>
                  <a :href="'mailto:' + (userData?.user?.data?.email || '')" class="font-small-2 font-weight-bold">
                    {{ userData?.user?.data?.email }}
                  </a> <br>
                  <b-badge variant="light-primary">
                    {{ userData?.user?.data?.department?.name }}
                  </b-badge> <br>
                  <b-badge variant="light-primary">
                    {{ userData?.user?.data?.designation?.name }}
                  </b-badge>
                </template>
              </div>
            </b-col>
          </b-row>


          <!-- attendance date-->
          <b-form-group label="Visit Attendance Date*">
            <ValidationProvider
                name="date"
                v-slot="{ errors }"
                vid="requested_date"
                rules="required"
            >
              <flat-pickr
                  v-model="attendanceDate"
                  class="form-control"
                  placeholder="Select Date"
                  :state="errors.length > 0 ? false : null"
                  id="attendance-date"
                  :disabled = "(applyEmployee && !selectUserId) || modelType === 'editModel'"
                  :config="attendanceDateConfig"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </ValidationProvider>
          </b-form-group>

          <b-row>
            <b-col cols="6">
              <b-form-group label="Requested Check In*">
                <validation-provider
                    #default="{ errors }"
                    name="check in"
                    vid="check_in"
                    rules="required"
                >
                  <flat-pickr
                      name="check-in"
                      id="check_in"
                      v-model="checkIn"
                      class="form-control"
                      placeholder="09:00 AM"
                      :config="{
                          enableTime: true,
                          noCalendar: true,
                          static: true,
                          dateFormat: 'H:i:S',
                          altInput: true,
                          altFormat: 'h:i K',
                          minuteIncrement: 1
                        }"
                      :disabled = "!attendanceDate || modelType === 'editModel'"
                      :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="6">
              <b-form-group label="Requested Check Out*">
                <validation-provider
                    #default="{ errors }"
                    name="check out"
                    vid="check_out"
                    rules="required"
                >
                  <flat-pickr
                      name="check-out"
                      id="check_out"
                      v-model="checkOut"
                      class="form-control"
                      placeholder="06:00 PM"
                      :config="{
                          enableTime: true,
                          noCalendar: true,
                          static: true,
                          dateFormat: 'H:i:S',
                          altInput: true,
                          altFormat: 'h:i K',
                          minuteIncrement: 1
                        }"
                      :disabled = "!attendanceDate || modelType === 'editModel'"
                      :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>

          <!-- description -->
          <b-form-group
              label="Description*"
              label-for="description"
          >
            <validation-provider
                #default="{ errors }"
                name="description"
                vid="description"
                rules="required"
            >
              <b-form-textarea
                  id="description"
                  v-model="description"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Description"
                  rows="3"
                  :disabled="modelType === 'editModel'"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <b-form-group
              label="Contact Person"
              label-for="contact_person"
              class="required-label"
          >
            <validation-provider
                #default="{ errors }"
                name="contact person"
                vid="contact_person"
                rules="required|max:255"
            >
              <b-form-input
                  id="name"
                  type="text"
                  v-model="contact_person"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Enter Contact Person"
                  :disabled = "modelType === 'editModel'"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <b-form-group
              label="Address*"
              label-for="address"
          >
            <validation-provider
                #default="{ errors }"
                name="address"
                vid="address"
                rules="required"
            >
              <b-form-textarea
                  id="address"
                  v-model="address"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Address"
                  rows="3"
                  :disabled = "modelType === 'editModel'"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>


          <template v-if="modelType == 'editModel'">
            <b-form-group
                label="Remarks"
                :class="checkApprovePermission(userData)
                ? 'required-label'
                : ''
            "
                label-for="remarks"
            >
              <validation-provider
                  #default="{ errors }"
                  name="remarks"
                  vid="remarks"
                  :rules="
                  checkApprovePermission(userData)
                  ? 'required'
                  : ''
              "
              >
                <b-form-textarea
                    id="required-remarks"
                    v-model="remarks"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Remarks"
                    rows="3"
                    :disabled="!checkApprovePermission(userData)"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </template>

          <!-- loading button -->
          <template v-if="isApplyFormSubmitLoading">
            <b-button class="float-right" variant="primary" disabled>
              <b-spinner small />
              Loading...
            </b-button>
          </template>

          <!-- submit button -->
          <template v-if="!approveButton && !isApplyFormSubmitLoading">
            <b-button
                type="submit"
                class="float-right"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
            >
              Submit
            </b-button>
          </template>

          <!-- approve button -->
          <template v-if="approveButton && !isApplyFormSubmitLoading">
            <b-button
                class="float-right"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="warning"
                @click="handleApproveClick"
            >
              Approve
            </b-button>
          </template>
        </b-form>
      </validation-observer>
    </b-modal>

    <!-- Reject  -->
    <b-modal
        id="modal-reject-form"
        centered
        title= "Reject Request"
        hide-footer
        @hidden="hiddenRejectModal"
        no-close-on-backdrop
        size="lg"
    >
      <validation-observer ref="rejectValidation">
        <b-form v-on:submit.prevent="rejectFromSubmit">

          <b-row class="justify-content-center">
            <b-col cols="12" md="8" lg="6">
              <div class="text-center">

                <template v-if="userData?.user_id">
                  <b-avatar default="''" :src="userData?.user?.data?.avatar === '' ? '/avatar.svg' : userData?.user?.data?.avatar" >
                  </b-avatar>
                  <h4>{{ userData?.user?.data?.name }} <b-badge variant="light-secondary">{{
                      userData?.user?.data?.employee_number
                    }}</b-badge></h4>
                  <a :href="'mailto:' + (userData?.user?.data?.email || '')" class="font-small-2 font-weight-bold">
                    {{ userData?.user?.data?.email }}
                  </a> <br>
                  <b-badge variant="light-primary">
                    {{ userData?.user?.data?.department?.name }}
                  </b-badge> <br>
                  <b-badge variant="light-primary">
                    {{ userData?.user?.data?.designation?.name }}
                  </b-badge>
                </template>
              </div>
            </b-col>
          </b-row>

          <!-- description -->
          <b-form-group
              label="Rejection Remarks*"
              label-for="rejection_remarks"
          >
            <validation-provider
                #default="{ errors }"
                name="Rejection Remarks"
                vid="rejection_remarks"
                rules="required"
            >
              <b-form-textarea
                  id="rejection_remarks"
                  v-model="rejectionRemarks"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Rejection Remarks"
                  rows="3"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <!-- submit button -->
          <template >
            <b-button
                type="submit"
                class="float-right"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
            >
              Submit
            </b-button>
          </template>


        </b-form>
      </validation-observer>
    </b-modal>

    <!-- apply modal -->
    <b-modal
        id="modal-complete-visiting-form"
        centered
        title="Complete Visiting Form"
        hide-footer
        @hidden="hiddenModal"
        no-close-on-backdrop
        size="lg"
    >
      <validation-observer ref="applyValidation">
        <b-form v-on:submit.prevent="applyFromSubmit">

          <!-- description -->
          <b-form-group
              label="Remarks"
              label-for="remarks"
              class="required-label"
          >
            <validation-provider
                #default="{ errors }"
                name="remarks"
                vid="remarks"
                rules="required"
            >
              <b-form-textarea
                  id="remarks"
                  v-model="complete_visiting_remarks"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Remarks"
                  rows="3"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <b-form-group
              :label="'Attachment'"
              label-for="file"
          >
            <validation-provider
                #default="{ errors }"
                name="attachment"
                vid="attachment"
            >
              <b-form-file
                  :id="'attachment'"
                  v-model="file"
                  multiple
                  :state="errors.length ? false : null"
                  placeholder="Choose a file or drop it here..."
                  drop-placeholder="Drop file here..."
                  @change="handleFileChange"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <!-- loading button -->
          <template v-if="isLoading">
            <b-button class="float-right" variant="primary" disabled>
              <b-spinner small />
              Loading...
            </b-button>
          </template>

          <!-- submit button -->
          <template v-else>
            <b-button
                type="submit"
                class="float-right"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
            >
              Submit
            </b-button>
          </template>
        </b-form>
      </validation-observer>
    </b-modal>

  </section>
</template>

<script>
import {
  BCard,
  BAvatar,
  BBadge,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  BButton,
  BForm,
  BModal,
  BCol,
  BRow,
  BCardText,
  BFormTimepicker,
  BSpinner, BListGroupItem, BListGroup,
  VBTooltip, BFormTextarea, BFormFile
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'

import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { mapGetters } from 'vuex'
import {
  ATTENDANCE_DETAILS_EDIT,
  VISIT_ATTENDANCE_APPROVE,
  VISIT_ATTENDANCE_COMPLETED_VISITING,
  VISIT_ATTENDANCE_MANAGE_DEPARTMENT,
  VISIT_ATTENDANCE_MANAGE_DIVISION,
  VISIT_ATTENDANCE_REJECT,
  VISIT_ATTENDANCE_SELF_APPROVE
} from '@/helpers/permissionsConstant'
import minutesToHours from '@/filter/minutesToHours'
import { EventBus } from '@/helpers/event-bus'
import UserSelect from '@/layouts/components/UserSelect.vue'
import flatPickr from 'vue-flatpickr-component';

export default {
  name: 'RemoteAttendanceDetailsView',
  components: {
    BFormFile,
    BFormTextarea,
    UserSelect,
    BListGroup,
    BListGroupItem,
    BForm,
    BButton,
    flatPickr,
    BCard,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    ValidationProvider,
    ValidationObserver,
    BModal,
    BCol,
    BRow,
    BCardText,
    BFormTimepicker,
    BSpinner,
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      ATTENDANCE_DETAILS_EDIT,
      VISIT_ATTENDANCE_COMPLETED_VISITING,
      user: null,
      attendanceDetails: null,
      modelType: '',
      attendance_activity_id: '',
      complete_visiting_remarks: '',
      visiting_loading: false,
      file: [],
      check_out: '',
      isLoading: false,
      pageLength: 10,
      columns: [

        {
          label: 'Check In',
          field: 'format_check_in',
          formatFn: this.formatFnTableCheckIn,
        },
        {
          label: 'Check Out',
          field: 'format_check_out',
          formatFn: this.formatFnTableCheckOut,
        },
        {
          label: 'Total (HH:mm)',
          field: 'format_worked_minutes',
          sortable: false,
        },
      ],
      rows: [],
      isAttendanceEditFormSubmitLoading: false,
      attendanceDateConfig: { minDate: 'today', static: true },
      applyEmployee: false,
      userData: null,
      isApplyFormSubmitLoading: false,
      approveButton: false,
      rejectionRemarks: "",
      attendanceDate: "",
      selectUserId: "",
    }
  },
  computed: {
    ...mapGetters({
      permissions: 'userModule/getPermissions',
      authUser: "userModule/getUser",
    }),
    isTodayRequestedDate() {
      if (!this.attendanceDetails?.requested_date) return false;

      const today = new Date().toISOString().split('T')[0]; // 'YYYY-MM-DD'
      return this.attendanceDetails.requested_date === today;
    }
  },

  async created() {
    this.loadItems()
  },
  methods: {

    resetForm() {
      this.modelType = ''
      this.attendanceDate = "";
      this.contact_person = "";
      this.address = "";
      this.description = "";
      this.checkOut = "";
      this.checkIn = "";
      this.selectUserId = "";
      this.remarks = "";
    },

    hiddenRejectModal() {
      this.$bvModal.hide("modal-reject-form");
      this.rejectionRemarks = "";
      this.rejectReconciliationId = "";
      this.userData = "";
    },

    hiddenApplyModal() {
      this.$bvModal.hide("modal-apply-form");
      this.resetForm();
      this.approveButton = false;
      this.applyEmployee = false;
      this.selectUserId = "";
    },

    async onShow(value) {
      this.modelType = "editModel";
      this.remoteAttendanceRequestId = value?.id;
      this.attendanceDate = value?.requested_date;
      this.checkIn = value?.start_time;
      this.checkOut = value?.end_time;
      this.description = value?.description;
      this.remarks = value?.remarks;
      this.contact_person = value?.contact_person;
      this.address = value?.address;
      this.userData = value;

      this.$bvModal.show("modal-apply-form");
    },

    checkApprovePermission(data) {
      if (
          (data.user_id === this.authUser?.id &&
              this.$permissionAbility(VISIT_ATTENDANCE_SELF_APPROVE, this.permissions))
          ||
          this.$permissionAbility(VISIT_ATTENDANCE_APPROVE, this.permissions)
          ||
          this.validateDeptOrDivisionHead(data.user)
      ) {
        return true;
      }

      return false;
    },

    checkRejectPermission(data) {
      if (
          // 1) The requester is acting on their own record *and* they have
          //    the “self‑reject” permission.
          (data.user_id === this.authUser?.id &&
              this.$permissionAbility(VISIT_ATTENDANCE_SELF_APPROVE, this.permissions))
          ||
          // 2) They hold the global “reject” permission.
          this.$permissionAbility(VISIT_ATTENDANCE_REJECT, this.permissions)
          ||
          // 3) They’re the user’s department or division head.
          this.validateDeptOrDivisionHead(data.user)
      ) {
        return true;
      }

      return false;
    },

    validateDeptOrDivisionHead(user)
    {
      if(user?.data?.id === this.authUser?.id)
      {
        return false
      }

      if(this.$permissionAbility(VISIT_ATTENDANCE_MANAGE_DEPARTMENT, this.permissions) && user?.data?.department?.head?.id === this.authUser?.id)
      {
        return true
      }

      return this.$permissionAbility(VISIT_ATTENDANCE_MANAGE_DIVISION, this.permissions) && user?.data?.department?.division?.head?.id === this.authUser?.id;
    },

    async onApprove(value) {
      //create a flag
      this.approveButton = true;

      await this.onShow(value);
    },

    handleApproveClick() {
      this.$swal({
        title: "Warning!",
        text: "Are You Sure You Want To Approve This?",
        icon: "warning",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "Ok",
        showLoaderOnConfirm: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {

            this.isApplyFormSubmitLoading = true

            await this.$api.post(
                `api/remote-attendances/${this.remoteAttendanceRequestId}/status`,
                {
                  status: 'approved',
                  remarks: this.remarks,
                }
            );

            this.resetForm()

            this.isApplyFormSubmitLoading = false

            // Assuming 'loadItems' is a method to fetch updated data
            await this.loadItems();

            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Success",
                icon: "BellIcon",
                variant: "success",
                text: "Successfully Approved",
              },
            });
            this.hiddenApplyModal();
          } catch (error) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Error",
                icon: "BellIcon",
                variant: "danger",
                text: error?.response?.data?.message || "An error occurred",
              },
            });
          } finally {
            this.isApplyFormSubmitLoading = false;
          }
        }
      });
    },

    rejectModalOpen(data) {
      this.$bvModal.show("modal-reject-form");
      this.userData = data;
      this.rejectReconciliationId = data?.id;
    },

    async rejectFromSubmit() {
      this.$refs.rejectValidation.validate().then(async (success) => {
        if (success) {
          try {
            this.$swal({
              title: "Warning!",
              text: `Are You Sure, You Want to Reject Request of ${this.userData?.user?.data?.name}?`,
              icon: "warning",
              customClass: {
                confirmButton: "btn btn-primary",
                cancelButton: "btn btn-outline-danger ml-1",
              },
              buttonsStyling: false,
              showCancelButton: true,
              confirmButtonText: "Ok",
              showLoaderOnConfirm: true,
            }).then(async (result) => {
              if (result.isConfirmed) {
                await this.$api.post(
                    `api/remote-attendances/${this.rejectReconciliationId}/status`,
                    {
                      status: 'rejected',
                      remarks: this.rejectionRemarks,
                    }
                );

                this.$bvModal.hide("modal-reject-form");
                this.rejectionRemarks = ''

                this.loadItems();

                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Success",
                    icon: "BellIcon",
                    variant: "success",
                    text: "Successfully Rejected",
                  },
                });
              }
            });
          } catch (error) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Error",
                icon: "BellIcon",
                variant: "danger",
                text: error?.response?.data?.message,
              },
            });
          }
        }
      });
    },

    statusVariant(value) {
      if (value === 'approved') {
        return "light-success";
      } else if (value === 'rejected') {
        return "light-danger";
      } else if (value === 'pending' || value === '') {
        return "light-warning";
      }
      return "light-warning";
    },

    handleFileChange(event) {
      this.file = Array.from(event.target.files)
    },

    async getLocationAndCheckIn() {
      this.isLoading = true;

      try {
        const location = await this.getCurrentLocation()

        if(!location)
        {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Error",
              icon: "AlertTriangleIcon",
              variant: "danger",
              text: 'Location not found.',
            },
          });

          this.isLoading = false;
          return;
        }

        await this.$api.post(`api/remote-attendance-requests/${this.attendanceDetails.id}/check-in`, location);

        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Success",
            icon: "BellIcon",
            variant: "success",
            text: "Check-in successful",
          },
        });

        this.loadItems();
      } catch (error) {

        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: typeof error === 'string' ? error : (error.response?.data?.message || "Check-in failed"),
          },
        });
      }

      this.isLoading = false;

    },

    async getLocationAndCheckOut() {
      this.isLoading = true;

      try {
        const location = await this.getCurrentLocation();

        if(!location) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Error",
              icon: "AlertTriangleIcon",
              variant: "danger",
              text: 'Location not found.',
            },
          });

          this.isLoading = false;
          return
        }

        await this.$api.post(`api/remote-attendance-requests/${this.attendanceDetails.id}/check-out`, location);

        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Success",
            icon: "BellIcon",
            variant: "success",
            text: "Check-out successful",
          },
        });
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: typeof error === 'string' ? error : (error.response?.data?.message || "Check-out failed"),
          },
        });
      }

      this.isLoading = false;
      this.loadItems();
    },

    async getCurrentLocation() {
      if (!navigator.geolocation) {
        this.error = "Geolocation is not supported.";
        return null;
      }

      // Check permission state
      try {
        const permission = await navigator.permissions?.query({ name: 'geolocation' });
        if (permission?.state === 'denied') {
          this.error = "Location access is blocked. Please enable it in Chrome settings.";
          return null;
        }
      } catch (e) {
        // Permissions API may not be supported in all browsers
      }

      // Wrap geolocation in a Promise
      return new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(
            (position) => {
              resolve({
                latitude: position.coords.latitude,
                longitude: position.coords.longitude
              });
            },
            (error) => {
              if (error.code === error.PERMISSION_DENIED) {
                this.error = "You denied location access. Enable it in settings: chrome://settings/content/location";
              } else {
                this.error = "Error getting location: " + error.message;
              }
              reject(error);
            }
        );
      });
    },

    formattedTime(value) {
      if (value == 0) return '0:00'
      return this.$moment
        .utc(value * 60 * 1000) // Convert minutes to milliseconds
        .format('H:mm')
    },
    formatFnTableCheckDate(value) {
      if (value) {
        return this.$moment(value).format('ll')
      }
    },
    formatFnTableCheckIn(value) {
      if (value) {
        return this.$moment(value, 'HH:mm:ss').format('LT')
      }
    },
    formatFnTableCheckOut(value) {
      if (value) {
        return this.$moment(value, 'HH:mm:ss').format('LT')
      }
    },

    showModal() {
      this.$bvModal.show('modal-complete-visiting-form')
    },
    hiddenModal() {
      this.$bvModal.hide('modal-complete-visiting-form')
      this.resetModal()
    },
    resetModal() {
      this.modelType = ''
      this.attendance_id = ''
      this.check_in = ''
      this.check_out = ''
    },

    applyFromSubmit() {
      this.$refs.applyValidation.validate().then(async (success) => {
        if (success) {
          try {
            try {
              const formData = new FormData()

              this.file.forEach((file, index) => {
                formData.append(`files[${index}]`, file)
              })
              formData.append('visiting_remarks', this.complete_visiting_remarks)

              await this.$api.post(`api/remote-attendances/${this.attendanceDetails.id}/complete`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
              })

              this.complete_visiting_remarks = ''
              this.file = []
              this.hiddenModal()
              this.loadItems()

              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Success",
                  icon: "BellIcon",
                  variant: "success",
                  text: "Successfully Approved",
                },
              });
            } catch (error) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Error",
                  icon: "BellIcon",
                  variant: "danger",
                  text: error?.response?.data?.message,
                },
              });
            }
          } catch (error) {
            if (error?.response?.data?.message) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Error",
                  icon: "BellIcon",
                  variant: "danger",
                  text: error?.response?.data?.message,
                },
              });
            }

            if (error?.response?.data?.errors) {
              this.$refs.applyValidation.setErrors(
                  error?.response?.data?.errors
              );
            }
          } finally {
            this.isApplyFormSubmitLoading = false;
          }
        }
      });
    },

    async loadItems() {
      try {
        const { id } = this.$route.params
        const res = await this.$api.get(
          `/api/remote-attendances/${id}?include=user`,
        )
        const { user } = res?.data?.data
        this.user = user?.data
        this.attendanceDetails = res?.data?.data

        const activities = await this.$api.get(
            `/api/remote-attendance-requests/${id}/activities`,
        )


        const data = activities?.data?.data;
        const meta = activities?.data?.meta;

        this.totalRecords = meta?.pagination?.total;
        this.rows = data

      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Warning',
            icon: 'BellIcon',
            variant: 'warning',
            text: error?.response?.data?.message,
          },
        })
      }
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";


.reconciled-time {
  color: red;
}

.flatpickr-wrapper{
  width: 100% !important;
}

.flatpickr-input[readonly]:disabled {
  color: #555555 !important; /* Custom color (light gray in this case) */
  background-color: transparent !important;
  cursor: not-allowed;
}

.map-container {
  width: 100%;
  height: 150px;
  overflow: hidden; /* ensures map does not overflow the cell */
}
.map-container iframe {
  display: block; /* remove inline spacing issues */
  width: 100%;
  height: 100%;
}

</style>
